import { render } from "./NotificationScaleStatementEditPane.vue?vue&type=template&id=5bc41ef3&ts=true"
import script from "./NotificationScaleStatementEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationScaleStatementEditPane.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__